import script from "./TableStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./TableStylePanel.vue?vue&type=style&index=0&id=e5523cbc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5523cbc"]])

export default __exports__